/**
 * Created by h3 on 2018-09-20.
 */
import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite} from "gsap";
import {Fruits} from "../Fruits";
import {FruitsGameModuleConfig} from "../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../FruitsSoundConfig";
import {FruitsGameMode} from "../gamemode/FruitsGameMode";
import {FruitsParsedGameData} from "../server/data/FruitsParsedGameData";
import {FruitsInitialWPController} from "../winpresentation/initial/FruitsInitialWPController";

export class FruitsBeforeSpinStopPresentationController extends BeforeSpinStopPresentationController {

    private _isNextSticky:boolean;
    private _mode:string;
    private _stickySymbol:string;
    private _data:FruitsParsedGameData;

    constructor(index:number) {
        super(index, "FruitsBeforeSpinStopPresentationController");

        EventHandler.addEventListener(this, SpinEvent.STOPPED, (event:GameEvent) => this.spinStopped());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.beforeSpinStart());

    }

    protected parseFeatureTriggered(data:FruitsParsedGameData):boolean {
        this._isNextSticky = data.nextMode === FruitsGameMode.STICKY_RESPIN;
        this._mode = data.mode;
        this._data = data;

        if(this._mode === FruitsGameMode.BONUS_GAME) {
            SlotGame.sound.playEffect(FruitsSoundConfig.BONUS_SWEEP_1);
        }
        return false;
    }

    protected startPresentation(timeline:TimelineLite):void {
        let restore = false;
        timeline.add(FruitsGameModuleConfig.stickyRespinView.getStickyAnimation2x2(this._stickySymbol, restore));
        timeline.add(FruitsGameModuleConfig.stickyRespinView.startRainbowLoop());

    }

    protected stopPresentation(isAborted:boolean):void {

    }

    protected getSpinStopDelay(data:FruitsParsedGameData):number {
        return this._timeline.totalDuration();
    }

    private spinStopped() {
        if(this._mode === FruitsGameMode.STICKY_RESPIN) {
            if(this._isNextSticky) {
                FruitsGameModuleConfig.stickyRespinView.stopRainbowLoop();
            } else {
                FruitsGameModuleConfig.stickyRespinView.resetRainbow();
            }
        }
    }

    private beforeSpinStart() {
        if(this._mode === FruitsGameMode.STICKY_RESPIN) {
            FruitsGameModuleConfig.stickyRespinView.startRainbowLoop();
        }

        EventHandler.dispatchEvent(new GameEvent(FruitsInitialWPController.END_ANIMATION));
        Fruits.bigWinView.fadeOutBigWin();
    }
}